export default function GetBaseUrl() {
  const enviroment = process.env.REACT_APP_ENV;
  const envData = require(`@/app/enviroments/enviroment.${
    enviroment || "production"
  }`);

  return envData.enviroment.baseUrl;
}
